/** Shared by discovery, article recommendations and SEO; accepts API ISO dates too. */
export function blogDate(value: unknown): Date | null {
    if (value == null || value === '') return null
    let date: Date
    if (value instanceof Date) date = value
    else if (typeof value === 'object' && 'seconds' in value && typeof value.seconds === 'number') {
        date = new Date(value.seconds * 1000)
    } else if (typeof value === 'object' && 'toDate' in value && typeof value.toDate === 'function') {
        date = value.toDate()
    } else if (typeof value === 'string' || typeof value === 'number') date = new Date(value)
    else return null
    return date instanceof Date && Number.isFinite(date.getTime()) ? date : null
}

export function normalizeBlogText(value: string): string {
    return value
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
}

export const BLOG_TOPICS = [
    {
        id: 'kariera',
        label: 'Práca a kariéra',
        keywords: ['praca', 'pracu', 'karier', 'zivotopis', 'staz', 'pohovor', 'zamestnan', 'onboarding']
    },
    { id: 'mentoring', label: 'Mentoring', keywords: ['mentor'] },
    {
        id: 'sebapoznanie',
        label: 'Sebapoznanie',
        keywords: ['sebapozna', 'wellbeing', 'impostor', 'silne stranky', 'sebarozvoj']
    },
    { id: 'dobrovolnictvo', label: 'Dobrovoľníctvo', keywords: ['dobrovol', 'pomahat', 'pomoc'] },
    {
        id: 'organizacie',
        label: 'Pre organizácie',
        keywords: ['organizaci', 'nezisk', 'firm', 'biznis', 'marketing', 'podnik']
    }
] as const

export function blogMatchesTopic(
    post: { title?: string; excerpt?: string; tags?: string[]; categories?: string[] },
    topicId: string
): boolean {
    const topic = BLOG_TOPICS.find((topic) => topic.id === topicId)
    if (!topic) return false
    const text = normalizeBlogText(
        [post.title, post.excerpt, ...(post.tags || []), ...(post.categories || [])].join(' ')
    )
    return topic.keywords.some((keyword) => text.includes(keyword))
}
